import React from "react";
import {
    Snackbar,
    Button,
    Stack,
    Slide,
    Fade,
    Box,
    Typography,
    Paper
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import './SnackbarAlert.css';

const iconMap = {
    success: <CheckCircleIcon className="alert-icon-large alert-icon-success" />,
    warning: <WarningIcon className="alert-icon-large alert-icon-warning" />,
    error: <ErrorIcon className="alert-icon-large alert-icon-error" />,
    info: <InfoIcon className="alert-icon-large alert-icon-info" />,
};

function SnackbarAlert({
    open,
    onClose,
    message,
    severity = "info",
    duration = 10000,
    actionButtons = [],
    autoDismiss = true,
    transition = "slide",
}) {
    const TransitionComponent =
        transition === "fade" ? Fade : (props) => <Slide {...props} direction="up" />;

    return (
        <Snackbar
            open={open}
            onClose={onClose}
            autoHideDuration={autoDismiss ? duration : null}
            TransitionComponent={TransitionComponent}
            className="snackbar-root"
        >
            <Paper className="snackbar-paper">
                <Box className="snackbar-header">
                    {iconMap[severity]}
                    <Typography variant="body1" fontWeight={600}>{message}</Typography>
                </Box>
                <Box className="snackbar-footer">
                    {actionButtons.length > 0 && (
                        <Stack direction="row" spacing={2} className="snackbar-button-group">
                            {actionButtons.map((btn, index) => (
                                <Button
                                    key={index}
                                    onClick={() => {
                                        btn.onClick?.();
                                        onClose?.();
                                    }}
                                    className="snackbar-action-btn"
                                >
                                    {btn.label}
                                </Button>
                            ))}
                        </Stack>
                    )}
                    <Button
                        variant="contained"
                        onClick={onClose}
                        className="snackbar-okay-btn"
                    >
                        Okay
                    </Button>
                </Box>
            </Paper>
        </Snackbar>
    );
}

export default SnackbarAlert;
